module.exports = __webpack_public_path__ + "static/media/downApp.5a778076.png";